import getSitePass from '../sitepass';

const axios = require('axios');

const getAllStock = async (urlSuffix) => {
  const response = await axios
    .get(process.env.VUE_APP_backend_url + urlSuffix, {
      params: {
        sitepass: getSitePass(),
      },
    });
  return response.data;
};

const filterToMainStock = (allStock) => {
  const mainItems = [];
  allStock.forEach((element) => {
    switch (element.Part_Number) {
      case ('10101-001'):
      case ('10102-001'):
      case ('10105-001'):
      case ('10105-002'):
      case ('10106-001'):
      case ('10501-002'):
      case ('10301-001'):
      case ('10301-003'):
      case ('10201-001'):
      case ('10901-002'):
      case ('10901-001'):
        mainItems.push(element);
        break;
      default:
        break;
    }
  });
  return mainItems;
};

const formatMainStock = (mainStock) => {
  const formattedMainStock = [];
  mainStock.forEach((element) => {
    formattedMainStock.push({
      label: `${element.Name} - ${element.Qty}`,
      value: element.Qty,
    });
  });
  return formattedMainStock;
};

// eslint-disable-next-line import/prefer-default-export
export const highValueData = async (typeOfStock) => {
  let allStock;
  if (typeOfStock === 'working') {
    allStock = await getAllStock('');
  } else allStock = await getAllStock('/getAllDamagedEquipment');
  const mainStock = filterToMainStock(allStock);
  const formattedMainStock = formatMainStock(mainStock);
  return formattedMainStock;
};



// WEBPACK FOOTER //
// ./src/helpers/highValueHelper.js